const validate = values => {
    const errors = {};
    // if (!values.mobile || values.mobile.length !== 11) {
    //     errors.mobile = 'این فیلد اجباری میباشد';
    // }
    if (!values.lastName) {
        errors.lastName = 'Required';
    }
    if (!values.email) {
        errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }
    return errors;
};

export default validate;
